var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 14.5833C11.6666 14.5833 12.25 14.5833 12.8333 15.75C12.8333 15.75 14.6862 12.8333 16.3333 12.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 14.0001C19.8333 17.2217 17.2216 19.8334 14 19.8334C10.7783 19.8334 8.16663 17.2217 8.16663 14.0001C8.16663 10.7784 10.7783 8.16675 14 8.16675C17.2216 8.16675 19.8333 10.7784 19.8333 14.0001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13.0471V9.66026C24.5 7.74692 24.5 6.79025 24.0285 6.16609C23.5571 5.54192 22.4911 5.23891 20.3592 4.63287C18.9026 4.21882 17.6185 3.71999 16.5927 3.26459C15.194 2.6437 14.4947 2.33325 14 2.33325C13.5053 2.33325 12.806 2.6437 11.4073 3.26459C10.3815 3.71999 9.09748 4.21881 7.64089 4.63287C5.50892 5.23891 4.44292 5.54192 3.97146 6.16609C3.5 6.79025 3.5 7.74692 3.5 9.66026V13.0471C3.5 19.6098 9.40656 23.5473 12.3597 25.1059C13.0679 25.4797 13.422 25.6666 14 25.6666C14.578 25.6666 14.932 25.4797 15.6403 25.1059C18.5934 23.5473 24.5 19.6098 24.5 13.0471Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon);
export default __webpack_public_path__ + "static/media/SafetyIcon.8b76069f7a2778b3b03a48bf0fc772d4.svg";
export { ForwardRef as ReactComponent };